import React from 'react';
import './SuperAdminLMSMain.css';

const SuperAdminLMSMain = () => {
  return (
    <div className="academy-page-shell superadmin-lms-main-page">
      <div className="superadmin-lms-main">
        <section className="lms-welcome-section">
          <h1>Welcome to the VirtuLingu Club LMS (SuperAdmin Main)</h1>
          <p className="lms-intro">This is your main entry point to the Learning Management System. Use the sidebar to access all features, manage users, courses, analytics, system settings, and more. You have full visibility and control.</p>
        </section>
      </div>
    </div>
  );
};

export default SuperAdminLMSMain;
